import {AuthModule} from "./Auth/AuthModule";


export const LoadMainModules = () => {

    return [
        ...AuthModule(),
    ]
}
